(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name configDistribution.controller:ConfigDistributionCtrl
   *
   * @description
   *
   */
  angular
    .module('configDistribution')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('ConfigDistributionCtrl', ConfigDistributionCtrl);

  function ConfigDistributionCtrl(EventManagerService,ConfigDistributionService,MessageService,PopupManager,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'ConfigDistributionCtrl';

    vm.model = {
        	searchOnGoing : false,
        	searchPanelToggle:true,
        	initialSearchDone: false,
        	editorMode:applicationConstants.EDITOR_STATUS.ADD,
        	searchCriteria:{
        		crewType :  null,
        		duration :  null,
        		maximumAllowed :  null,
        		status :  null,
        		distributionIdentifier : null
             },
             masterList:{
            	 crewTypes : [],
            	 status : [],
            	 identifiers :[]
             },
             gridDataList:[],
             selectedRow:null,
             isElasticLoadingVisible:false
     };

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);


  vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
  };

  vm.searchByOptions = function(searchParams){
    setDefault();
    vm.searchConfigs();
  };

  vm.searchConfigs = function() {
		vm.model.gridDataList = [];
		vm.model.searchCriteria.startPosition = 1;
		vm.model.initialSearchDone = true;
		searchConfigs();
	};

	vm.addButtonClick = function(){
		vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
		vm.model.selectedRow = ConfigDistributionService.getNewConfig();
	};

	vm.selectRowData = function (selectedRowData) {
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
        vm.model.selectedRow = ConfigDistributionService.formatSelectedRowData(selectedRowData);
  };

  vm.submitNewConfig = function(action, selectedItem){
     vm.model.selectedRow = selectedItem;
       if (action === applicationConstants.EDITOR_STATUS.DELETE){
         deleteConfig(vm.model.selectedRow);
       }else{
         saveConfigDistribution(vm.model.selectedRow);
       }
  };

  function deleteConfig(selectedItem){
    var param = {
      title: 'Confirmation',
      messages: ["Do you want to delete this record"],
      flags: selectedItem
    };
    PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
  }


  function confirmDeleteDialog(pass) {
      if(pass==='YES'){
        ConfigDistributionService.deleteDistributionConfig(vm.model.selectedRow,
          function (response) {
              MessageService.success('Successfully deleted the record!');
              vm.searchConfigs();
          },
          function (error) {
              MessageService.error(error);
          }
        );
      }
  }

	function saveConfigDistribution(selectedRow){
		 showLoader(true);
		 var postdataArray = [];
		 postdataArray.push(selectedRow);
		 ConfigDistributionService.saveDistributionConfig(
				 postdataArray, function (response) {
               MessageService.success('Successfully saved the records!');
               setIdentifiersList();
               vm.model.enableUpdateAllButtion = false;
               vm.searchConfigs();
               vm.model.searchPanelToggle = false;
               showLoader(false);
               vm.model.searchOnGoing = false;
		         },
		         function (error) {
                MessageService.error(error);
                showLoader(false);
		         }
		  );
	}

	function getNextSetOfRecords() {
     vm.model.isElasticLoadingVisible = true;
     if(!vm.model.searchOnGoing){
        vm.model.searchOnGoing = true;
        searchConfigs();
     }
    }

    function setDefault() {
    	vm.model.searchCriteria.pageSize = 100;
      vm.model.searchCriteria.startPosition = 1;
      vm.model.masterList.status = ConfigDistributionService.searchStatusOptions();
      vm.addButtonClick();
    }

    function searchConfigs() {
        showLoader(true);
        var searchParams = vm.model.searchCriteria;
        ConfigDistributionService.searchDistributionConfigGridData(
        	vm.model.masterList.crewTypes,
        	searchParams,
            function (gridData,startPosition) {
                updateGridDataList(gridData);
                updateGridSearchStartPosition(startPosition);
                vm.model.searchPanelToggle = false;
                showLoader(false);
                vm.model.searchOnGoing = false;
                vm.addButtonClick();
            },
            function (error) {
                MessageService.error(error);
                showLoader(false);
            }
        );
    }

    function showLoader(flag) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
            flag: flag,
            target: 'configDistribution',
            animationName: 'crewing-loader'
        });
    }

    function updateGridDataList(gridData) {
        angular.forEach(gridData, function (data) {
            vm.model.gridDataList.push(data);
        });
        vm.model.isElasticLoadingVisible = false;
    }

    function updateGridSearchStartPosition(startPosition) {
   	 	vm.model.searchCriteria.startPosition = startPosition;
    }

    function setIdentifiersList() {
      vm.model.masterList.identifiers = [];

      ConfigDistributionService.searchIdentifiers(
        function(identifiers){
          vm.model.masterList.identifiers= identifiers;
        },
        function(error){
          MessageService.error(error);
        }
      );
    }

    (function() {
      // identifiers list
      setIdentifiersList();

      // crew type list
      ConfigDistributionService.searchCrewTypeMasterData(
        function(crewTypes){
          vm.model.masterList.crewTypes= crewTypes;
        },
        function(error){
          MessageService.error(error);
        }
      );

      // set default view
      setDefault();
    }) ();
  }
}());
